import {GridCellKind} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridCellKind';
import {IGridCell} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {AEmpty} from '@mintdata/mint-kit/api/values/AEmpty';

export class FrameCell implements IGridCell
{
    private constructor(public readonly value:IValue | null)
    {
    }

    getKind():GridCellKind
    {
        return GridCellKind.FrameCell;
    }

    isEqualTo(other:IGridCell):boolean
    {
        return other &&
            other.getKind() === GridCellKind.FrameCell &&
            (other as FrameCell).value &&
            (other as FrameCell).value.isEqualTo(this.value);
    }

    toString():string
    {
        return this.toDisplayString();
    }

    toDisplayString():string
    {
        const value = this.value;

        if( value.isEmpty )
            return '--';
        else if( value.isError )
            return '#error';
        else if( value.isFrame )
            return '#nested';
        else
            return value.toString();
    }

    public static fromValue(value:IValue):IGridCell
    {
        return new FrameCell(value);
    }

    public static newEmptyCell():IGridCell
    {
        return new FrameCell(AEmpty.Value);
    }
}

